import styled from '@emotion/styled';
import {Button} from '@bosch/react-frok';

export const ContentWrapper = styled.div`
    display: inline-flex;
    flex-wrap: wrap;
    width: 100%;
    overflow-y: auto;
`;

export const TextWrapper = styled.div`
    display: flex;
    justify-content: space-between;
    font-size: small;
    margin-bottom: 0;
`;

export const HeaderWarning = styled.p`
    color: red;
    font-weight: bold;
    margin-top: 0;
    margin-bottom: 0;
`;

export const HeaderWarningDetails = styled.p`
    color: red;
    font-weight: normal;
    margin-top: 0;
    margin-bottom: 1rem;
    white-space: pre-line;
`;

export const DialogEditActionsWrapper = styled.div`
    display: inline-grid;
    grid-template-columns: 2fr 3fr 3fr;
    column-gap: 0.5rem;
    width: 100%;
`;

export const ActionButton = styled(Button)<{ fontSize: number }>`
    margin: 1rem 0 0 0;
    min-width: 120px;
    max-width: 240px;
    height: 48px;
    font-size: ${(props) => props.fontSize}px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;
